import { Component, OnInit } from '@angular/core';
import { UserContextService } from '@core/services';
import { take } from 'rxjs';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

@Component({
  selector: 'sp-not-found',
  template: `
    <ng-container *ngIf="userContext$ | async as userContext">
      <sp-page-content-container>
        <div class="container">
          <div class="title">Sorry...It's not you. It's us.</div>
          <div class="details">
            An error has occured and we are working to get it fixed for you.
          </div>
          <div class="no-tax-forms-svg">
            <img [src]="imageSrc" />
          </div>
        </div>
      </sp-page-content-container>
    </ng-container>
  `,
  styles: [
    `
      .container {
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .title {
        font-size: 2rem;
        padding-bottom: 2rem;
      }

      .button-container {
        padding-top: 2rem;
      }
    `,
  ],
})
export class ErrorPageComponent implements OnInit {
  imageSrc = 'assets/errors/sure-not-found.svg';
  userContext$ = this.userContextService.userContext$;

  constructor(private userContextService: UserContextService) {}

  ngOnInit(): void {
    this.userContextService.userContext$.pipe(take(1)).subscribe(context => {
      const programCode = context.programCode.toLowerCase();
      if (
        ProgramCodeConstants.SurepayrollProgramCodeConstants.indexOf(programCode) >= 0 ||
        ProgramCodeConstants.RunpayrollProgramCodeConstants.indexOf(programCode) >= 0
      ) {
        this.imageSrc = `assets/errors/sure-not-found.svg`;
      } else if (ProgramCodeConstants.PaychexProgramCodeConstants.indexOf(programCode) >= 0) {
        this.imageSrc = `assets/errors/pxgo-not-found.svg`;
      } else if (ProgramCodeConstants.TruistProgramCodeConstants.indexOf(programCode) >= 0) {
        this.imageSrc = `assets/errors/sunt-not-found.svg`;
      }
    });
  }
}
